"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dNaturalLogTransform = void 0;
const rc_js_util_1 = require("rc-js-util");
const a_cartesian2d_user_transform_1 = require("./a-cartesian2d-user-transform");
const e_cartesian2d_user_transform_1 = require("./e-cartesian2d-user-transform");
/**
 * @public
 * Apply natural log as a transform, range must be greater than 0.
 */
class Cartesian2dNaturalLogTransform extends a_cartesian2d_user_transform_1.ACartesian2dUserTransform {
    constructor(xTransformEnabled, yTransformEnabled) {
        super();
        this.xTransformEnabled = xTransformEnabled;
        this.yTransformEnabled = yTransformEnabled;
        this.transformId = e_cartesian2d_user_transform_1.ECartesian2dUserTransform.NaturalLog;
        this.userTransformId = Cartesian2dNaturalLogTransform.transformId;
        this.forwardX = rc_js_util_1._Fp.identity;
        this.forwardY = rc_js_util_1._Fp.identity;
        this.reverseX = rc_js_util_1._Fp.identity;
        this.reverseY = rc_js_util_1._Fp.identity;
        this.updateTransform(xTransformEnabled, yTransformEnabled);
    }
    updateTransform(xTransformEnabled, yTransformEnabled) {
        super.updateTransform(xTransformEnabled, yTransformEnabled);
        Object.assign(this, Cartesian2dNaturalLogTransform.getTransforms(xTransformEnabled, yTransformEnabled));
    }
    static forwardTransform(value) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(value > 0, "range must be greater than 0");
        return Math.log(value);
    }
    static reverseTransform(value) {
        return Math.pow(Math.E, value);
    }
    static getTransforms(xTransformEnabled, yTransformEnabled) {
        let forwardX;
        let forwardY;
        let reverseX;
        let reverseY;
        if (xTransformEnabled) {
            forwardX = Cartesian2dNaturalLogTransform.forwardTransform;
            reverseX = Cartesian2dNaturalLogTransform.reverseTransform;
        }
        else {
            forwardX = rc_js_util_1._Fp.identity;
            reverseX = rc_js_util_1._Fp.identity;
        }
        if (yTransformEnabled) {
            forwardY = Cartesian2dNaturalLogTransform.forwardTransform;
            reverseY = Cartesian2dNaturalLogTransform.reverseTransform;
        }
        else {
            forwardY = rc_js_util_1._Fp.identity;
            reverseY = rc_js_util_1._Fp.identity;
        }
        return {
            forwardX: forwardX,
            forwardY: forwardY,
            reverseX: reverseX,
            reverseY: reverseY,
        };
    }
}
exports.Cartesian2dNaturalLogTransform = Cartesian2dNaturalLogTransform;
Cartesian2dNaturalLogTransform.transformId = Symbol("natural log");
//# sourceMappingURL=cartesian2d-natural-log-transform.js.map